import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import MenuBar from '../../components/menu-bar/MenuBar';
import { WebApiCalls } from '../../webApiCalls/webApiCalls';
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import {
	UpdateCartCount,
	UpdateCartAmount
} from "../../redux/actions/postActions";
import MyStorage from '../../common/MyStorage';
import { validateDOBFormat, validateEmail, validatePostalCode } from '../../common/validation';
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { KMTracking, KMIdentifier } from '../../components/Tracking/KMTracking';

export const useMountEffect = (fun) => useEffect(fun, []);
function CompleteProfile(props) {
	const [givenname, setGivenName] = useState('');
	const [showGivenNameError, setShowGivenNameError] = useState(false)
	const [given_name_error, setGivenNameError] = useState('')
	const [familyname, setFamilyName] = useState('');
	const [gender, setGendar] = useState('');
	const [mobilephonenumber, setMobileNumber] = useState('');
	const [password, setPassword] = useState('');
	const [showPasswordError, setShowPasswordError] = useState(false)
	const [password_error, setPasswordError] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')
	const [showConfirmPasswordError, setShowConfirmPasswordError] = useState(false)
	const [confirm_password_error, setConfirmPasswordError] = useState('')
	const [email, setEmail] = useState('');
	const [showEmailError, setShowEmailError] = useState(false)
	const [email_error, setEmailError] = useState('This does not look like a valid email address')
	const [postalcode, setPostalCode] = useState('');
	const [show_postal_error, set_show_postal_error] = useState(false)
	const [nopostal, setNoPostal] = useState(false)
	const [birthdate, setBirthdate] = useState('');
	const [showDOBError, setShowDOBError] = useState(false)
	const [dob_error, setDOBError] = useState('This does not look like a valid DOB format (YYYY-MM-DD)')
	const [callconsent, setCallConsent] = useState<string>("N")
	const [emailconsent, setEmailConsent] = useState<string>("N");
	const [smsconsent, setSmsConsent] = useState<string>("N")


	const [privacy_policy, setPrivacyPolicy] = useState(false);

	const [password_type, setPasswordType] = useState(true)
	const [confirm_password_type, setConfirmPasswordType] = useState(true)
	const [show_api_error, setShowApiError] = useState(false)
	const [api_error, setApiError] = useState('')
	const [is_loading, setIsLoading] = useState(false)
	const [no_privacy_policy, setNoPrivacyPolicy] = useState(false)


	const nameRef = useRef<any>();
	const surnameRef = useRef<any>();
	const emailRef = useRef<any>();
	const dobRef = useRef<any>();
	const genderRef = useRef<any>();
	const postCodeRef = useRef<any>();
	const passwordRef = useRef<any>();
	const confirmPasswordRef = useRef<any>();

	useEffect(() => {
		let _mobile = props?.location?.state.mobile
		if (_mobile) {
			setMobileNumber(_mobile)
		}
	}, [])
	useEffect(() => {
		const listener = event => {
			if (event.code === "Enter" || event.code === "NumpadEnter") {
				event.preventDefault();
				handleSignUp();
			}
		};
		document.addEventListener("keydown", listener);
		return () => {
			document.removeEventListener("keydown", listener);
		};
	}, [givenname, email, postalcode, password, confirmPassword, privacy_policy]);
	const tracker = async (eventName, _kmprops) => {
		await KMTracking(eventName, _kmprops)
	}

	const handleGivenName = (event) => {
		setShowGivenNameError(false)
		setGivenName(event.target.value)
	}
	const handleSurName = (event) => {
		setFamilyName(event.target.value);
	}
	const handleEmail = (event) => {
		setEmail(event.target.value);
		let valid = validateEmail(event.target.value);
		setShowEmailError(!valid)
		if (!valid) {
			setEmailError('This does not look like a valid email address')
		}
	}
	const handleDOB = (date) => {
		console.log('eventevent = ', date.target.value)
		setBirthdate(date.target.value);
		let valid = validateDOBFormat(moment(date.target.value, 'YYYY-MM-DD').format('YYYY-MM-DD'))

		setShowDOBError(!valid)
		console.log('date DaTEEEEEEE', valid)
	}
	const handleGender = (event) => {
		setGendar(event?.target.value)
	}
	const handlePostalCode = (event) => {
		setPostalCode(event.target.value);
		setNoPostal(false)
		let valid = validatePostalCode(event.target.value)
		set_show_postal_error(!valid)
	}
	const handlePassword = (event) => {
		setShowPasswordError(false)
		setPassword(event.target.value);
		if (event.target.value.length < 8) {
			setShowPasswordError(true)
			setPasswordError("Your password should contain at least 8 characters")
			passwordRef.current.focus();
		}
	}
	const handleConfirmPassword = (event) => {
		setShowConfirmPasswordError(false)
		setConfirmPassword(event.target.value);
		if (event.target.value != password) {
			setShowConfirmPasswordError(true)
			setConfirmPasswordError("Confirm Password does not match")
			confirmPasswordRef.current.focus();

		}
	}
	// const handleMarketConsent = (event) => {
	// 	setMarketConsent(event.target.checked)
	// }
	const handlePrivacyPolicy = (event) => {
		setPrivacyPolicy(event?.target.checked);
		setNoPrivacyPolicy(false)
	}
	const loginUser = () => {
		new WebApiCalls().LoginUser(mobilephonenumber, password).then(result => {
			fetchingToken(result.data);
			setIsLoading(false)
			// localStorage.setItem("LoggedIn", "true")
		}).catch(error => {
			setIsLoading(false)

			console.log('Error: ', error)
		})
	}
	const fetchingToken = async (data) => {
		const storage = new MyStorage();
		let obj = {
			contactID: data.memberInfo.contact_id,
			email: data.memberInfo.email,
			authentication: data.jwt,
			phoneNumber: data.memberInfo.mobilephonenumber ? data.memberInfo.mobilephonenumber : '',
			name: data.memberInfo.givenname + ' ' + (data.memberInfo.familyname ? data.memberInfo.familyname : '')
		};
		storage.setloggedIn("true")
		storage.setContactIDFrasers(obj.contactID)
		// storage.setEmailFrasers(obj.email)
		storage.setauthenticationFrasers(obj.authentication)
		// storage.setPhoneNumber(obj.phoneNumber)
		storage.setName(obj.name)
		await KMIdentifier(obj.contactID)
		await new WebApiCalls().getToken(obj).then(async (response) => {

			if (response.AccessToken) {
				storage.setUserId(response.AccessToken.UserId);
				storage.setaccess_token(response.AccessToken.access_token)
				storage.setSsoCode(response.SsoCode)
				let body = {
					FirstName: data.firstName,
					LastName: data.lastName,
					DisplayName: data.name,
					Description: data.contact_id
				}
				await new WebApiCalls()
					.updateUserInfo(response?.AccessToken?.UserId, body, response?.AccessToken?.access_token).then((updateUserResult) => {
						props?.history?.push(`/`)
					}).catch(error => console.log('Error in updateUserInfo', error))
			}

		});
	}
	const handleSignUp = () => {
		setIsLoading(true)
		if (showGivenNameError || showEmailError || showPasswordError || showConfirmPasswordError ||
			show_postal_error || no_privacy_policy
		) {
			setIsLoading(false)
			return
		}

		if (
			givenname && email && password && confirmPassword &&
			mobilephonenumber && postalcode && privacy_policy
		) {
			let data = {
				mobilephonenumber,
				password,
				email,
				givenname,
				familyname,
				gender,
				postalcode,
				callconsent,
				emailconsent,
				smsconsent,
				"fn": "join",
			}
			
			if (birthdate) {
				data['birthdate'] = moment(birthdate).format('YYYY-MM-DD')
			}
			new WebApiCalls().CompleteProfileJoin({ data }).then(response => {
				if (response) {
					if (!response.data && response?.error) {
						setShowApiError(true)
						setApiError(response.error)
						setIsLoading(false)

						return
					} else if (response?.data?.status) {
						let eventData = {
							email: email,
							contact: mobilephonenumber,
							step: 'Registered Profile',
							'Current Page': 'Registration Profile',
							'Source Page': 'Registration OTP'
						}
						tracker("pageViewed", eventData)

						loginUser();
						// localStorage.setItem("LoggedIn", "true")
						// props?.history?.push(`/`)
					}
				} else {
					setIsLoading(false)

				}
			}).catch((error) => {
				console.log('Error catch: ', error)
				setIsLoading(false)

			})
		} else {
			if (!givenname) {
				setShowGivenNameError(true)
				setGivenNameError('Please enter given name')
				nameRef.current.focus();
				setIsLoading(false)
				return
			} else if (!email) {
				setShowEmailError(true)
				setEmailError('Please enter email')
				emailRef.current.focus();
				setIsLoading(false)
				return
			}
			// else if (!birthdate) {
			// 	setShowDOBError(true)
			// 	setDOBError('Please Select Date of Birth')
			// 	dobRef.current.focus();
			// 	setIsLoading(false)
			// 	return
			// }
			else if (!postalcode) {
				setNoPostal(true)
				setIsLoading(false)
				postCodeRef.current.focus();

			} else if (!password) {
				setShowPasswordError(true)
				setPasswordError('Please enter password')
				passwordRef.current.focus();
				setIsLoading(false)
				return
			} else if (!confirmPassword) {
				setShowConfirmPasswordError(true)
				setConfirmPasswordError('Please retype your password')
				confirmPasswordRef.current.focus();
				setIsLoading(false)
				return
			} else if (!privacy_policy) {
				setNoPrivacyPolicy(true)
				setIsLoading(false)
			}
		}
	}
	const ErrorView = (_text) => {
		return (<div className="error" style={{ display: "block", marginTop: 10, marginBottom: 10 }}>{_text}</div>)
	}


	return (
		<div>
			<div className="viewport"></div>

			{/* /container */}
			<div className="container">

				{/* header */}
				<Header props={props} />
				{/* /header */}


				<MenuBar props={props} />

				{/* login */}
				<div className="login">
					<div className="title">Complete your profile</div>

					<form name="complete">

						<fieldset>
							<label htmlFor="">GIVEN NAME*</label>
							<input type="text" name="givenname" id="givenname" onChange={handleGivenName}
								ref={nameRef} />
							{showGivenNameError && ErrorView(given_name_error)}
						</fieldset>

						<fieldset>
							<label htmlFor="">SURNAME</label>
							<input type="text" name="surname" id="surname" onChange={handleSurName}
								ref={surnameRef} />
						</fieldset>

						<fieldset>
							<label htmlFor="">EMAIL*</label>
							<input type="text" name="email" id="email" onChange={handleEmail}
								ref={emailRef} />
							{showEmailError && ErrorView(email_error)}
						</fieldset>

						<fieldset>
							<label htmlFor="">DATE OF BIRTH</label>
							<input
								className="form-control"
								type="date"
								placeholder='YYYY-MM-DD'
								onChange={handleDOB}
								max={moment(new Date().setFullYear(new Date().getFullYear() - 18)).format('YYYY-MM-DD')}
								id="publishAt_input"
								ref={dobRef} />
							{/* <DatePicker
								selected={birthdate}
								onChange={handleDOB}
								dateFormat="d MMMM yyyy"
								scrollableYearDropdown
								showYearDropdown
								// showMonthDropdown
								maxDate={new Date().setFullYear(new Date().getFullYear() - 16)}
								yearDropdownItemNumber={100}
								customInputRef={dobRef}
							/> */}
							{/* <input type="text" id="datepicker" onChange={handleDOB} placeholder="DD/MM/YY"
							 ref={dobRef} /> */}
							{showDOBError && ErrorView(dob_error)}
							<div className="note">You must be over 18 years old for a Frasers Experience account</div>
						</fieldset>

						<fieldset>
							<label htmlFor="">GENDER</label>
							<select name="gender" id="gender" onChange={handleGender} ref={genderRef} >
								<option value="" disabled selected>Please Select</option>
								<option value="Male">Male</option>
								<option value="Female">Female</option>
								<option value="Not Specified">Not Specified</option>
							</select>
						</fieldset>

						<fieldset>
							<label htmlFor="">POSTAL CODE*</label>
							<input type="text" name="postalcode" id="postalcode" onChange={handlePostalCode} ref={postCodeRef} />
							{nopostal == true &&
								ErrorView("Please enter postal code")}
							{show_postal_error == true &&
								ErrorView("This does not look like a valid postal code")}
						</fieldset>

						<fieldset className="pw-field">
							<label htmlFor="">PASSWORD</label>
							<input type={password_type ? 'password' : 'text'} className="pw" name="password" id="password" onChange={handlePassword}
								ref={passwordRef} />
							<div className="visibility" onClick={() => setPasswordType(!password_type)}><img src={password_type ? "images/icon-invisible.svg" : "images/icon-visible.svg"} alt="" /></div>
							{showPasswordError && ErrorView(password_error)}
						</fieldset>


						<fieldset className="pw-field">
							<label htmlFor="">CONFIRM PASSWORD</label>
							<input type={confirm_password_type ? 'password' : "text"} className="pw" name="confirmpw" id="confirmpw" onChange={handleConfirmPassword}
								ref={confirmPasswordRef} />
							<div className="visibility" onClick={() => setConfirmPasswordType(!confirm_password_type)}><img src={confirm_password_type ? "images/icon-invisible.svg" : "images/icon-visible.svg"} alt="" /></div>
							{showConfirmPasswordError && ErrorView(confirm_password_error)}
						</fieldset>

						{/* <fieldset className="check">
							<input type="checkbox" value={'marketconsent'} onChange={handleMarketConsent} />
							<div className="text">I consent to receive promotional marketing messages from Frasers Property Retail Management Pte. Ltd.</div>
						</fieldset> */}
						<div className="text" style={{ fontWeight: 500, marginBottom: 15 }}>
							<p>I consent to recieve promotional marketing messages
								from Frasers Property Retail Managment Pte. Ltd.</p>
						</div>
						{/* Consent promotions check boxes */}
						<div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0px' }}>
							<div className="text" style={{ flex: '8' }}>
								Recieve promotions via calls
							</div>
							{/* Special Designed Checkbox */}
							<div className="custom-checkbox1" style={{ flex: 1 }}>
								<label className="switch" htmlFor="checkbox1">
									<input type="checkbox" id="checkbox1" checked={callconsent == "Y" ? true : false} onChange={(e) => setCallConsent(e.target.checked ? "Y" : "N")} />
									<div className="slider round"></div>
								</label>
							</div>
						</div>

						<div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0px' }}>
							<div className="text" style={{ flex: '8' }}>
								Recieve promotions via email
							</div>
							{/* Special Designed Checkbox */}
							<div className="custom-checkbox2" style={{ flex: 1 }}>
								<label className="switch" htmlFor="checkbox2">
									<input type="checkbox" id="checkbox2" checked={emailconsent == "Y" ? true : false} onChange={(e) => setEmailConsent(e.target.checked ? "Y" : "N")} />
									<div className="slider round"></div>
								</label>
							</div>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0px' }}>
							<div className="text" style={{ flex: '8' }}>
								Recieve promotions via SMS
							</div>
							{/* Special Designed Checkbox */}
							<div className="custom-checkbox3" style={{ flex: 1 }}>
								<label className="switch" htmlFor="checkbox3">
									<input type="checkbox" id="checkbox3" checked={smsconsent == "Y" ? true : false} onChange={(e) => setSmsConsent(e.target.checked ? "Y" : "N")} />
									<div className="slider round"></div>
								</label>
							</div>
						</div>
						{/* Consent promotions check boxes */}
						<fieldset className="check">
							<input style={{marginBottom: "auto"}} type="checkbox" value={'privacy_policy'} onChange={handlePrivacyPolicy} />
							<div className="text" style={{textAlign:"justify"}}>I have read and agree to the <a target="_blank" href="https://www.frasersexperience.com/terms-of-use">Terms of Use</a> , <a target="_blank" href="https://www.frasersproperty.com/privacy-policy">Privacy Policy</a> and the <a target="_blank" href="https://www.frasersexperience.com/privacy-policy-addendum/">Privacy Policy Addendum</a> which include how my personal data may be collected, used, disclosed and processed by Frasers Property Retail Management Pte. Ltd. (“Frasers”) and its related corporations.</div>
						</fieldset>
						{no_privacy_policy == true &&
							ErrorView("Please accept our Privacy Policy and Terms of Use")}
						{show_api_error && ErrorView(api_error)}
						<div className="loadingBlackButton"
							onClick={(event) => {
								event.preventDefault()
								handleSignUp();
							}}
						>{
								is_loading ?
									<Loader
										type="TailSpin"
										color="white"
										height={18}
										width={18}
									/>
									:
									"CREATE ACCOUNT"
							}</div>

					</form>

				</div>
				{/* /login */}

			</div>
			{/* /container */}

			<Footer />


		</div>
	)
}
const mapStateToProps = (state) => {
	const { cart_count } = state.UserReducer
	return { cart_count }
};
const actions = {
	UpdateCartCount,
	UpdateCartAmount
};
export default connect(mapStateToProps, actions)(CompleteProfile);